import React from 'react';
import { Box, Typography } from '@mui/material';
import PatientDocumentsList from '../../components/PatientDocuments';

const PatientDocuments = ({ patientId }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Patient Documents
      </Typography>
      <PatientDocumentsList patientId={patientId} />
    </Box>
  );
};

export default PatientDocuments; 